import { Typography } from "@material-ui/core"
import AppTranslation, { AppTranslationMessage } from "../../../app/AppTranslation";

type ErrorMessageParam = {
    message?: string
}

const ErrorMessage: React.FC<ErrorMessageParam> = ({ message }) => {
    const msg = message ? message : AppTranslation.getMessage(AppTranslationMessage.APP_ERROR_MESSAGE_RETRY);
    return <Typography color='error' variant='caption'>{msg}</Typography>;
};

export default ErrorMessage;